import { checkIsInternalUser, getProfile } from '@src/globalStore/profileStore';
import { useMemo } from 'react';

// temp hardcode until we have a proper user level permission setup
const CAN_MANAGE_PROMPT_USERNAMES = [
  'athakur@conviva.com', // Abhishek Thakur
  'hlin@conviva.com', // Hubert Lin
  'jjesus@conviva.com', // Jose Jesus
  'junhwikim@conviva.com', // Junhwi Kim
  'ksankar@conviva.com', // Kailash Sankar
  'pmulchandani@conviva.com', // Pankaj Mulchandani
  'shs@conviva.com', // Shruthi H S
  'skandula@conviva.com', // Siddeshwar Reddy Kandula
  'sxu@conviva.com', // Sarah Xu
  'gnadarajan@conviva.com', // Gopinathan Nadarajan
  'jfartyal@conviva.com', // Jatin Fartyal
  'svatsyayan@conviva.com', // Shubhansh Vatsyayan
];

const useCanManageSystemPrompt = () => {
  const isInternal = useMemo(() => checkIsInternalUser(), []);
  const { username } = getProfile();
  const canManage = useMemo(() => {
    return isInternal && CAN_MANAGE_PROMPT_USERNAMES.includes(username);
  }, [username, isInternal]);
  return canManage;
};

export default useCanManageSystemPrompt;
